export default __webpack_public_path__ + "static/media/iconeCliente.8d0d5a5a.png";